import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Formik } from "formik";
import * as Yup from "yup";
import { jwtDecode } from "jwt-decode";
import Card from "../../../components/Card";
import url from "../../../configs/config";
import FocusError from "../../../components/error/error-focus";
import AlertNotificationSimple from "../../../components/alert/alert-notification-simple";
import InputField from "../../../components/input/input-field";
import { roleTypes } from "../../../data/roleType";

const LocationAdd = () => {
  const alertRef = useRef(null);
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [decodedToken, setDecodedToken] = useState();
  const token = localStorage.getItem("coyote-token");
  const [alert, setAlert] = useState({
    message: "",
    type: "",
    show: false,
    alertFor: "",
  });
  const initialFormData = { name: "" };

  useEffect(() => {
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setDecodedToken(decoded?.user);
      } catch (error) {
        console.error("Failed to decode token", error);
      }
    }
  }, [token]);

  const handleSubmit = async (values, { setSubmitting }) => {
    setSubmitting(true);
    try {
      const config = {
        headers: { Authorization: `${token}` },
      };
      const response = await axios.post(
        `${url.backendURL}location/`,
        values,
        config
      );

      if (alertRef.current) {
        alertRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }

      setAlert({
        message: response.data.message,
        type: "success",
        show: true,
        alertFor: "location-add",
      });

      setErrors({});
      setTimeout(() => {
        setAlert({ show: false, alertFor: "", message: "", type: "" });
        navigate(`/dashboard/app/location-list`);
      }, 2000);
    } catch (err) {
      handleError(err, "location-add");
    } finally {
      setSubmitting(false);
    }
  };

  const handleError = (err, alertFor) => {
    const { response } = err;
    if (alertRef.current) {
      alertRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    if (response.data.error === "jwt expired" || response?.data?.error === "Unauthorized. User not found") {
      localStorage.removeItem("coyote-token");

      navigate(
        `/${
          decodedToken?.roles?.some(
            (role) => role.role_type === roleTypes.SUPER_ADMIN
          )
            ? "admin"
            : "user"
        }/auth/sign-in`,
        {
          state: { status: "expired" },
        }
      );
    } else {
      const responseErrors = response?.data?.error || {};
      setErrors(responseErrors);
      setAlert({
        message: response ? response.data.message : "An error occurred",
        type: "danger",
        show: true,
        alertFor,
      });
      setTimeout(() => {
        setAlert({ show: false, alertFor: "", message: "", type: "" });
      }, 5000);
    }
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .matches(
        /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9!@#$%^&*()_+=[\]{};':"\\|,.<>/?-\s]*$/,
        "Location must contain at least one letter or number"
      )
      .min(1, "Location must be at least 1 character long")
      .max(255, "Location must not exceed 255 characters")
      .trim()
      .required("Location is required"),
  });

  const handleReset = (resetForm) => {
    resetForm();
    setErrors({});
  };

  return (
    <>
      <Formik
        initialValues={initialFormData}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({
          values,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          resetForm,
        }) => (
          <Form onSubmit={handleSubmit}>
            <FocusError />
            <Row>
              <Col xl="12" lg="12" ref={alertRef}>
                <Card>
                  <Card.Header className="d-flex justify-content-between">
                    <div
                      className="breadcrumb header-title"
                      style={{ cursor: "pointer" }}
                    >
                      <h4
                        onClick={() => navigate("/dashboard/app/location-list")}
                        className="text-primary card-title"
                        style={{ cursor: "pointer" }}
                      >
                        <span>Location</span>
                      </h4>
                      <h4 className="mx-2 card-title">{">"}</h4>
                      <h4 className="card-title">Add</h4>
                    </div>
                  </Card.Header>
                  <Card.Body>
                    <AlertNotificationSimple
                      type={alert.type}
                      message={alert.message}
                      show={alert.show}
                      onClose={() => setAlert({ ...alert, show: false })}
                    />
                    <div className="new-location-info">
                      <InputField
                        className="col-md-10 form-group"
                        type="text"
                        name="name"
                        placeholder="Enter Location"
                        value={values.name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        asterick={true}
                        errorMessage={errors?.name}
                        label="Location"
                      />

                      <hr />
                      <div className="d-flex flex-wrap flex-md-nowrap justify-content-end gap-1 gap-md-2">
                        <Button
                          type="button"
                          className="me-2 me-md-5 px-3 px-md-4"
                          variant="btn btn-light"
                          onClick={() => handleReset(resetForm)} // Reset the form
                        >
                          Reset
                        </Button>

                        <Button
                          type="submit"
                          disabled={isSubmitting}
                          variant="btn btn-primary"
                          className="me-2 me-md-5 px-3 px-md-4"
                        >
                          Submit
                        </Button>
                        <Button
                          type="button"
                          className=" px-3 px-md-4"
                          variant="btn btn-danger"
                          onClick={() =>
                            navigate("/dashboard/app/location-list")
                          }
                        >
                          Cancel
                        </Button>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default LocationAdd;
